// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditCircleFilledSvg from "@ant-design/icons-svg/es/asn/RedditCircleFilled";
import AntdIcon from '../components/AntdIcon';

var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditCircleFilledSvg
  }));
};

RedditCircleFilled.displayName = 'RedditCircleFilled';
export default React.forwardRef(RedditCircleFilled);